// extracted by mini-css-extract-plugin
module.exports = {"sliderWrapper":"Carousel_sliderWrapper__-KywY","slider":"Carousel_slider__F6MhA"};